import { asText, Content, isFilled } from '@prismicio/client';

import { Box, Heading } from '@preventx/oxygen';
import { RichText } from '@preventx/prismic-services';

// Services
import { applicationEnv } from '@/services/env/shared';

// Components
import { Link } from '@/components/Actions/Link';
import { BrandLogo } from '@/components/Graphics/BrandLogo';

type WithBrandImageProps = {
  slice: Content.RegionSliceWithBrandImage;
};

export const WithBrandImage = ({ slice }: WithBrandImageProps) => {
  const { primary } = slice;
  const { link, content, title, brand_logo, brand_position, image_caption } =
    primary;

  const { WebsiteUrl } = applicationEnv();

  return (
    <Box component="div" addSwitcher>
      {brand_position === 'Left' && isFilled.select(brand_logo) && (
        <Box component="figure">
          <BrandLogo logo={brand_logo} addServiceLogoClass={false} />

          {isFilled.richText(image_caption) && (
            <Box component="figcaption">
              <RichText
                variant="default"
                content={image_caption}
                websiteUrl={WebsiteUrl}
              />
            </Box>
          )}
        </Box>
      )}

      <Box component="div" addFlow>
        <Heading component="h2" addHeadlineTitle>
          {asText(title)}
        </Heading>

        <RichText content={content} variant="default" websiteUrl={WebsiteUrl} />

        {isFilled.link(link) && (
          <Link
            href={link}
            as="default"
            type="button"
            variant="solid"
            colour="primary"
            retainSearchParams
          >
            {link.text}
          </Link>
        )}
      </Box>

      {brand_position === 'Right' && isFilled.select(brand_logo) && (
        <Box component="figure">
          <BrandLogo logo={brand_logo} addServiceLogoClass={false} />

          {isFilled.richText(image_caption) && (
            <Box component="figcaption">
              <RichText
                variant="default"
                content={image_caption}
                websiteUrl={WebsiteUrl}
              />
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
};
